import { formatDate } from "../../../../utils/date";
import { isBefore, isEqual } from "date-fns";
import { Event } from "../../../../context/eventsContext/reducer";

const EventDate = (props: {
  className?: string,
  event: Event
}) => {

  const dateString = () => {
    if (!props.event.date) {
      return props.event.coming_soon_message ? props.event.coming_soon_message : "To Be Determined"
    } else if (props.event.date && props.event.end_date) {
      const start = new Date(props.event.date.replace(/-/g, '\/'));
      const end = new Date(props.event.end_date.replace(/-/g, '\/'));

      if(isEqual(end, start)) {
        return formatDate(start, 'MMMM do yyy');  
      }

      if (start.getMonth() === end.getMonth()) {
        return formatDate(start, 'MMMM do') + " - " + formatDate(end, 'do yyy')
      } else if(!isEqual(start, end)) {
        return formatDate(start, 'MMMM do') + " - " + formatDate(end, 'MMMM do yyy');
      }
    } else {
      return formatDate(new Date(props.event.date.replace(/-/g, '\/')), 'MMMM do yyy');
    }
  }

  const textColor = () => {
    if(!props.event.date) return false;
    const inPast = isBefore(new Date(props.event.date.replace(/-/g, '\/')), new Date());
    
    return inPast ? "text-gray-400 ignore" : "text-red";
  }

  return (
    <div>
      <div className={`flex ${ textColor() }`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 mr-2 ignore"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <div>
          { dateString() }
        </div>
      </div>
    </div>
  )
}

export default EventDate;